module.exports = __webpack_public_path__ + "img/Adobe.a2f887b.svg";